var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"header_nav"},[_c('div',{staticClass:"l"},[_c('GlobalLogo')],1),_c('div',{staticClass:"r"},[_c('Nav',{attrs:{"hrefList":_vm.hrefList}})],1)]),_c('p',{staticClass:"detail_title"},[_vm._v(_vm._s(_vm.deteil_title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }